import "./styles.less";

import { Affix } from "antd";
import { LeadButtons } from "../../../Components/Property/InformationRequest/LeadButtons/web";
import React from "react";

export const PropertyAffixBottom = ({ id, mode }) => {
	return (
		<Affix className={"pd_affix_bottom"} offsetBottom={0}>
			<div className="pd_affix_bottom_content">
				<LeadButtons id={id} mode={mode} />
			</div>
		</Affix>
	);
};
